import React from "react";
import BreadCrumb from "./breadCrumb";
import HeaderLogo from "./headerLogo";
import { useEntity } from "apps/console/context/entity";
import { ADMIN_CONSOLE_TITLE } from "shared/utils/constants";
import UserProfile from "apps/console/modules/profile";
import UserDropdown from "shared/components/userDropdown";
import useConsoleUserDropdownService from "./hooks/useDrodownService";

export default function Header() {
  const { clientDetails, eventSeriesDetails, registrationDetails, programDetails } = useEntity();
  const dropdownService = useConsoleUserDropdownService();

  React.useEffect(() => {
    window.document.title = ADMIN_CONSOLE_TITLE;
  }, []);

  return (
    <header className="consoleLayoutHeader consoleHeader" id="header">
      <div className="consoleHeader_wrapper">
        <div className="consoleHeader_left">
          <HeaderLogo clientLogoUrl={clientDetails?.logoUrl} />
        </div>
        <div className="consoleHeader_right">
          <BreadCrumb
            clientName={clientDetails?.name}
            eventSeriesName={eventSeriesDetails?.name}
            registrationName={registrationDetails?.name}
            programName={programDetails?.name}
            programType={programDetails?.programType}
          />
          <UserDropdown dropdownItemList={dropdownService.dropdownItemList} />
          <UserProfile />
        </div>
      </div>
    </header>
  );
}
